import React from 'react';

import SvgIcon, { IProps } from '../SvgIcon';

export default (props: IProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M21 16.42v3.54a1 1 0 01-.93 1c-.44.02-.8.04-1.07.04A16 16 0 013.05 3.93a1 1 0 011-.93h3.53a.5.5 0 01.5.45A13.52 13.52 0 009.35 8c.1.2.03.44-.15.57l-2.15 1.54a13.05 13.05 0 006.84 6.85l1.54-2.16a.46.46 0 01.57-.15 13.9 13.9 0 004.55 1.27.5.5 0 01.45.5z"/>
  </SvgIcon>
);